import { TokenPercentageButton } from "@/domains/tokens/components/token-percentage-button"

export type ITokenPercentageButtons = {
  symbol: string
  imageURL: string
  decimals: number
  calculateValue: (percentage: number) => string
}

export const TokenPercentageButtons = ({
  disabled,
  token,
  onClick,
}: {
  disabled?: boolean
  token: ITokenPercentageButtons | null | undefined
  onClick: (amount: string) => void
}) => {
  return (
    <div className="grid w-full grid-cols-5 items-center gap-1 md:gap-2">
      <TokenPercentageButton
        label="0%"
        token={token}
        hideTooltip
        onClick={() => onClick("0")}
        percentage={0}
        disabled={disabled}
      />
      <TokenPercentageButton
        label="25%"
        token={token}
        onClick={(v) => onClick(v)}
        percentage={0.25}
        disabled={disabled}
      />
      <TokenPercentageButton
        label="50%"
        token={token}
        onClick={(v) => onClick(v)}
        percentage={0.5}
        disabled={disabled}
      />
      <TokenPercentageButton
        label="75%"
        token={token}
        onClick={(v) => onClick(v)}
        percentage={0.75}
        disabled={disabled}
      />
      <TokenPercentageButton
        label="100%"
        token={token}
        onClick={(v) => onClick(v)}
        percentage={1}
        disabled={disabled}
      />
    </div>
  )
}
